/**
 * example:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645476119917,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"breakPrice":100.0},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"BREAK","symbol":"XYZ"},
	"date": "2022-02-21T15:42:00.471-0500",
	"timestamp": "1645476120475"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) breakPrice
 */
export function breakParser(pluginTemplate) {
    const parsedObject = {
        breakPrice: null
    }
    if(pluginTemplate) {
        parsedObject.breakPrice=pluginTemplate.breakPrice;
    }
    return parsedObject;
}